
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M11.667 13.208a.87.87 0 00-.472 1.137.87.87 0 01-.188.947l-2.459 2.46a1.738 1.738 0 01-2.458 0l-1.845-1.844a1.74 1.74 0 010-2.46l2.462-2.459a.88.88 0 01.949-.189.87.87 0 10.663-1.607 2.637 2.637 0 00-2.84.567l-2.463 2.459a3.484 3.484 0 000 4.918l1.845 1.845a3.476 3.476 0 004.917 0l2.459-2.46a2.616 2.616 0 00.566-2.843.87.87 0 00-1.136-.47z"}}),_c('path',{attrs:{"d":"M8.24 13.764a.828.828 0 001.158 0l6.372-6.375a.82.82 0 00-1.158-1.159L8.24 12.605a.82.82 0 000 1.159z"}}),_c('path',{attrs:{"d":"M18.985 4.86l-1.844-1.843a3.483 3.483 0 00-4.918 0l-2.46 2.459a2.614 2.614 0 00-.566 2.842.87.87 0 101.608-.664.87.87 0 01.189-.945l2.458-2.459a1.739 1.739 0 012.46 0l1.844 1.845a1.74 1.74 0 010 2.46l-2.462 2.454a.882.882 0 01-.949.189.87.87 0 10-.665 1.607 2.63 2.63 0 002.843-.566l2.459-2.459a3.484 3.484 0 00.003-4.92z"}})])])
          )
        }
      }
    